"use strict";
window.theme = window.theme || {}

/* T5.77 — Lazy-load Swiper (151KB) on first quick-view open. Off the PDP,
   swiper-bundle.min.js is no longer parsed site-wide (see theme.liquid); it's
   fetched on demand here the first time a quick-view modal builds its gallery.
   On the PDP, window.Swiper already exists (loaded statically for the product
   gallery) so this resolves instantly without touching the network. The
   promise is cached on theme so rapid/concurrent opens share one fetch.
   On any failure we resolve (not reject) so the await below behaves exactly
   like the pre-T5.77 code did if Swiper were ever unavailable — the modal's
   other logic (add-to-cart binding, .active) still runs. */
theme.ensureSwiper = function () {
    if (window.Swiper) return Promise.resolve();
    if (theme.__swiperPromise) return theme.__swiperPromise;
    theme.__swiperPromise = new Promise(function (resolve) {
        var src = window.__lkcSwiperSrc;
        if (!src) { resolve(); return; }
        var s = document.createElement('script');
        s.src = src;
        s.onload = function () { resolve(); };
        s.onerror = function () { resolve(); };
        document.head.appendChild(s);
    });
    return theme.__swiperPromise;
};

theme.QuickView = function() {
    function QuickView() {
        this.selector = {
            cartdrawer: document.getElementById('cart-drawer'),
            cartdraweroverlay: document.getElementById('cart-drawer-overlay'),
            cartcountbubble: document.getElementById('cart-count-bubble'),
            formcartdrawer: document.getElementById('form-cart-drawer'),
            cartdraweritemcount: document.getElementById('cart-drawer-item-count'),
            cartdrawerupsell: document.getElementById('cart-drawer-upsell'),
            cartdrawercheckout: document.querySelector('#cart-drawer > .cart-footer > #checkout'),
            mainquickmodalview: document.getElementById('quick-view-modal'),
            quickviewmodalclose: document.getElementById('quick-view-modal-close'),
            quickviewmodalrender: document.getElementById('quick-view-modal-render-wrapper'),
            sectionfeaturedproducts: document.querySelectorAll('.section-featured-products'),
            sectiondynamiccollection: document.getElementById('dynamic-collection')
        }
        this.state = {
            swiper: null,
            rendered: false,
            editMode: false
        }
        this.load();
    }
    QuickView.prototype.load = function() {
        var _ = this;
        /* T5.48 — Bind the STABLE openers + modal controls ONCE. load() runs at
           init AND inside every add-to-cart .finally; without this guard it
           re-added listeners to the persistent tiles / section containers /
           render-wrapper each time (no removeEventListener anywhere), so a single
           tap fired N+1 concurrent modal renders + stacked submit handlers after
           N adds — the listener-stacking behind the cart "first add does nothing"
           race. The cart drawer's own edit / free-gift buttons live in the
           re-rendered #form-cart-drawer, so they are (re)bound idempotently in
           bindCartButtons() instead. */
        if (_._bound) { _.bindCartButtons(); return; }
        _._bound = true;
        if(_.selector.sectiondynamiccollection) {
            _.selector.sectiondynamiccollection.addEventListener('click', event => {
                if(event.target.closest('.featured-quick-view-modal-btn')) {
                    !_.state.rendered && _.rendercontent(event.target.closest('.featured-quick-view-modal-btn').dataset.productUrl);
                }
            })
        }
        if(_.selector.sectionfeaturedproducts.length > 0) {
            Array.from(_.selector.sectionfeaturedproducts).map(el => {
                el.addEventListener("click", event => {
                    if(event.target.closest('.featured-quick-view-modal-btn')) {    
                    !_.state.rendered && _.rendercontent(event.target.closest('.featured-quick-view-modal-btn').dataset.productUrl);
                    }                
                })
            })
        }
        const quickviewmodalbtn = document.querySelectorAll('.quick-view-modal-btn');
        if(quickviewmodalbtn.length > 0) {
            quickviewmodalbtn.forEach(btn => {
                btn.addEventListener('click', event => {
                    !_.state.rendered && _.rendercontent(event.target.closest('button').dataset.productUrl);
                })
            })
        }
        if(_.selector.quickviewmodalclose) {
            _.selector.quickviewmodalclose.addEventListener('click', () => {
                _.selector.mainquickmodalview.classList.remove('active');
                _.state.rendered = false;
                _.state.editMode = false;
            })
        }
        if(_.selector.quickviewmodalrender) {

            _.selector.quickviewmodalrender.addEventListener("click", event => {
                if(event.target.closest('.lkc-qv__close')) {
                    /* T5.24 — close the sheet via its own header X (delegated, since
                       the modal content is injected after load). */
                    _.selector.mainquickmodalview.classList.remove('active');
                    _.state.rendered = false;
                    _.state.editMode = false;
                    return;
                }
                if(event.target.closest('label.option-value')) {
                    const inputSelected = document.getElementById(`${event.target.closest('label.option-value').getAttribute('for')}`);
                    inputSelected.checked = true;
                    /* T6.08 — deferred size re-mark (runs after ALL the synchronous
                       variant logic below, including the T5.22 recovery path's early
                       return). Mirrors the PDP's deferMark pattern. */
                    setTimeout(function () { _.markSizes(); }, 0);
                    /* T5.24 — keep the "Colour · Value" inline label in sync. */
                    var _qvSel = _.selector.quickviewmodalrender.querySelector('.lkc-qv__selval[data-for-option="'+inputSelected.dataset.optionName+'"]');
                    if(_qvSel) _qvSel.textContent = ' · ' + inputSelected.value;
                    const variantOptionsSelected = event.target.closest('.variant-options').querySelectorAll('.option-values > input:checked');
                    const variantOptionsFit = [];
                    const variantOptionsSize = [];
                    Array.from(variantOptionsSelected).map(option => {
                        if(option.dataset.optionName === 'Colour' && option.checked) {
                            variantOptionsFit.push(option.value);                            
                        }
                        if(option.dataset.optionName === 'Colour' && option.checked || option.dataset.optionName ==='Fit' && option.checked || option.dataset.optionName ==='Style' && option.checked) {
                            variantOptionsSize.push(option.value);
                        }
                    })
                    const optionValuesAvailable = [];
                    const selectedVariantOptions = [];
                    const quickViewOptionInputs = _.selector.quickviewmodalrender.querySelectorAll('.option-values input[type="radio"]');
                    const quickViewSelectVariants = _.selector.quickviewmodalrender.querySelector('select[name="id"]');
                    const optionSelected = [];
                    if(quickViewOptionInputs.length > 0) {
                        Array.from(quickViewOptionInputs).map(option => {
                            option.classList.remove("disabled");
                            if(option.checked) {
                                selectedVariantOptions.push(option);
                                optionSelected.push(option.value);
                            }                            
                        })
                    }
                    if (quickViewSelectVariants) {
                        let hitMatched = false;
                        Array.from(quickViewSelectVariants.options).map(option => {
                                const optionTextSplit = option.text.split(" / ");
                                const optionFoundFit = variantOptionsFit.every(optValue => optionTextSplit.includes(optValue));
                                const optionFoundSize = variantOptionsSize.every(optValue => optionTextSplit.includes(optValue));
                                if(optionFoundFit) {
                                    const setAvailableFit = optionTextSplit.filter(availableValue => !variantOptionsFit.includes(availableValue));
                                    if(!optionValuesAvailable.includes(setAvailableFit[0])) {
                                        optionValuesAvailable.push(setAvailableFit[0]); 
                                    }                                                                
                                }
                                if(optionFoundSize) {                                    
                                    const setAvailableSize = optionTextSplit.filter(availableValue => !variantOptionsSize.includes(availableValue));
                                    if(!optionValuesAvailable.includes(setAvailableSize[0])) {    
                                        optionValuesAvailable.push(setAvailableSize[0]);
                                    }                                   
                                }
                            let allValuesMeetCondition = true;
                            if (optionSelected.length > 0) {
                                const splitOption = option.text.split(" / ");
                                let copyArray1 = splitOption.slice().sort();
                                let copyArray2 = optionSelected.slice().sort();
                                allValuesMeetCondition = copyArray1.every((value, index) => value === copyArray2[index]);
                            }                            
                            if(allValuesMeetCondition) {
                                option.selected = true;     
                                hitMatched = true;                    
                                const ImageSelected = document.getElementById(option.dataset.imageId);
                                ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index)));
                            } else {
                                option.selected = false;                                                
                            }
                        });
                        Array.from(quickViewOptionInputs).map(el => {
                            if(!optionValuesAvailable.includes(el.value) && el.dataset.optionName !== 'Colour') {
                                el.classList.add('disabled');
                            } else {
                                el.classList.remove('disabled');
                            }
                        })
                        if(!hitMatched) {
                            /* T5.22 — Stranded-size recovery (e.g. switching Fit to
                               Oversized when the current Size isn't offered). Instead of
                               dead-ending on UNAVAILABLE, auto-select the first available
                               variant for what the user just chose, sync the pickers to it,
                               and enable Add to Cart. Only falls through to the original
                               UNAVAILABLE state if NOTHING is available. */
                            var keep = variantOptionsSize; // colour + fit the user wants to keep
                            var recover = Array.from(quickViewSelectVariants.options).find(function(opt){
                                return opt.dataset.available === "true" && keep.every(function(v){ return opt.text.split(" / ").includes(v); });
                            });
                            if(!recover){
                                recover = Array.from(quickViewSelectVariants.options).find(function(opt){
                                    return opt.dataset.available === "true" && opt.text.split(" / ").includes(inputSelected.value);
                                });
                            }
                            if(recover){
                                var recoverValues = recover.text.split(" / ");
                                Array.from(quickViewOptionInputs).forEach(function(inp){
                                    inp.checked = recoverValues.includes(inp.value);
                                    if(inp.checked) inp.classList.remove("disabled");
                                });
                                /* T5.24 — sync the "· Value" labels to the recovered selection. */
                                Array.from(quickViewOptionInputs).forEach(function(inp){
                                    if(inp.checked){ var s = _.selector.quickviewmodalrender.querySelector('.lkc-qv__selval[data-for-option="'+inp.dataset.optionName+'"]'); if(s) s.textContent = ' · ' + inp.value; }
                                });
                                Array.from(quickViewSelectVariants.options).forEach(function(o){ o.selected = false; });
                                recover.selected = true;
                                var imgEl = document.getElementById(recover.dataset.imageId);
                                imgEl && (_.state.swiper.slideTo(parseInt(imgEl.dataset.index)));
                                var atcBtn = _.selector.quickviewmodalrender.querySelector("form > .add-to-cart");
                                if(atcBtn) atcBtn.disabled = false;
                                var unavailEl = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .unavailable");
                                unavailEl && unavailEl.classList.remove("active");
                                var modeEl = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > " + (_.state.editMode ? ".edit-mode" : ".add-mode"));
                                modeEl && modeEl.classList.add("active");
                                _.syncAvailability();
                                return;
                            }
                            Array.from(selectedVariantOptions).map(el => {
                                el.classList.add("disabled");
                            });
                            _.selector.quickviewmodalrender.querySelector("form > .add-to-cart").disabled = true;                         
                            const unavailablemode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .unavailable");
                            unavailablemode && unavailablemode.classList.add("active");
                            if(_.state.editMode) {
                                const editmode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .edit-mode");
                                editmode && editmode.classList.remove("active");
                            } else {
                                const addmode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .add-mode");
                                addmode && addmode.classList.remove("active");
                            }                     
                        } else {
                            _.syncAvailability();
                        }                     
                    }
                }               
            })
        }
        _.bindCartButtons();
    }
    QuickView.prototype.syncAvailability = function() {
        var _ = this;
        const form = _.selector.quickviewmodalrender.querySelector('form#data-product-form');
        if (!form) return;
        const select = form.querySelector('select[name="id"]');
        const selectedVariant = select && select.options[select.selectedIndex];
        const available = !!selectedVariant && selectedVariant.dataset.available === 'true';
        const button = form.querySelector('.add-to-cart');
        if (!button) return;
        button.disabled = !available;
        const unavailablemode = button.querySelector('.unavailable');
        const addmode = button.querySelector('.add-mode');
        const editmode = button.querySelector('.edit-mode');
        if (unavailablemode) unavailablemode.classList.toggle('active', !available);
        if (addmode) addmode.classList.toggle('active', available && !_.state.editMode);
        if (editmode) editmode.classList.toggle('active', available && !!_.state.editMode);
        if (selectedVariant) {
            _.selector.quickviewmodalrender.querySelectorAll('#variant-selected-price, .lkc-qv__tt-price .regular-price').forEach(function(price) {
                price.textContent = selectedVariant.dataset.regularPrice;
            });
            const compareAtPrice = selectedVariant.dataset.onSale === 'true' ? selectedVariant.dataset.compareAtPrice : '';
            _.selector.quickviewmodalrender.querySelectorAll('#variant-selected-compare-at-price, .lkc-qv__tt-price .compare-at-price').forEach(function(price) {
                price.textContent = compareAtPrice;
            });
        }
    }
    /* T6.08 — modal twin of the PDP's lkcMarkSizes (component-product-page.js
       ~line 1160): greys SIZE chips that have no available variant for the
       currently selected non-Size options, using the real data-available flags
       on the hidden select[name="id"]. Runs on every render (open/edit) and,
       deferred, after every option click — so the modal's size state matches
       the PDP beat for beat. Class-only (.disabled) per the modal's own
       convention; component-quick-view.css already styles it and blocks
       clicks via pointer-events:none. No caching: the form is re-injected on
       every open, so we read fresh each call. */
    QuickView.prototype.markSizes = function() {
        var _ = this;
        var pf = _.selector.quickviewmodalrender.querySelector('form#data-product-form');
        if (!pf) return;
        var sel = pf.querySelector('select[name="id"]');
        if (!sel) return;
        var sizeRadios = pf.querySelectorAll('.option-values input[type="radio"][data-option-name="Size"]');
        if (!sizeRadios.length) return;
        var ctx = [];
        pf.querySelectorAll('.option-values input[type="radio"]:checked').forEach(function (i) {
            if (i.dataset.optionName !== 'Size') ctx.push(i.value);
        });
        var avail = {};
        Array.from(sel.options).forEach(function (o) {
            if (o.dataset.available !== 'true') return;
            var parts = o.text.split(' / ');
            if (ctx.every(function (v) { return parts.indexOf(v) !== -1; })) {
                avail[parts[parts.length - 1]] = true;
            }
        });
        sizeRadios.forEach(function (r) {
            if (avail[r.value]) {
                r.classList.remove('disabled');
            } else {
                r.classList.add('disabled');
            }
        });
    };
    QuickView.prototype.bindCartButtons = function() {
        var _ = this;
        /* T5.48 — edit / free-gift openers live inside the re-rendered cart
           drawer; (re)bind them idempotently on each cart update. Old buttons die
           with the replaced #form-cart-drawer innerHTML, so this can't stack, and
           the per-element _qvBound flag guards against a double bind. */
        document.querySelectorAll('.quick-view-modal-edit-btn').forEach(btn => {
            if (btn._qvBound) return;
            btn._qvBound = true;
            btn.addEventListener('click', event => {
                !_.state.rendered && _.rendereditcontent(event.target.closest('button').dataset.productUrl, event.target.closest('button').dataset.itemId, event.target.closest('button').dataset.itemKey, event.target.closest('button').dataset.itemQty, theme.CartTransactions.snapshot(event.target.closest('button')));
            })
        });
        document.querySelectorAll('.quick-view-modal-free-gift-btn').forEach(btn => {
            if (btn._qvBound) return;
            btn._qvBound = true;
            btn.addEventListener('click', event => {
                !_.state.rendered && _.rendereditfreegiftcontent(event.target.closest('button').dataset.productUrl, event.target.closest('button').dataset.itemId, event.target.closest('button').dataset.itemKey, event.target.closest('button').dataset.itemQty, theme.CartTransactions.snapshot(event.target.closest('button')));
            })
        });
    }
    QuickView.prototype.cartOperation = async function(form, itemKey) {
        if (form._lkcCartPending || form._lkcCartReviewRequired) return;
        form._lkcCartPending = true;
        const button = form.querySelector('.add-to-cart');
        button?.classList.add('active', 'js-loading');
        try {
            const body = new FormData(form);
            body.set('sections', 'cart-drawer');
            const answer = itemKey
                ? await theme.CartTransactions.edit(body, itemKey, form._lkcCartSnapshot)
                : await theme.CartTransactions.add(body);
            const refreshed = await theme.CartTransactions.render(answer);
            theme.CartTransactions.message(form, answer);
            if (answer.locked || answer.refreshFailed) {
                form._lkcCartReviewRequired = true;
                if (button) button.disabled = true;
            }
            if (refreshed && ['success', 'recovered', 'partial'].includes(answer.status)) {
                this.selector.mainquickmodalview.classList.remove('active');
                this.state.rendered = false;
                this.state.editMode = false;
            }
        } finally {
            form._lkcCartPending = false;
            button?.classList.remove('active', 'js-loading');
        }
    }
    QuickView.prototype.addtocart = async function(form) {
        return this.cartOperation(form);
    }
    QuickView.prototype.loadProductHTML = async function(productURL) {
        const sectionURL = new URL(productURL);
        sectionURL.searchParams.set('sections', 'quick-view-modal');
        const response = await fetch(sectionURL.toString());
        if (!response.ok) throw new Error('LKC_QUICK_VIEW_FETCH_FAILED');
        const data = await response.json();
        if (!data || typeof data['quick-view-modal'] !== 'string') throw new Error('LKC_QUICK_VIEW_SECTION_MISSING');
        const htmlDoc = new DOMParser().parseFromString(data['quick-view-modal'], 'text/html');
        const container = htmlDoc.getElementById('quick-view-modal');
        const form = container && container.querySelector('form#data-product-form');
        if (!form || !form.querySelector('select[name="id"]') || !form.querySelector('button.add-to-cart')) {
            throw new Error('LKC_QUICK_VIEW_FORM_MISSING');
        }
        this.selector.quickviewmodalrender.innerHTML = container.innerHTML;
    }
    QuickView.prototype.navigateToProduct = function(url) {
        window.location.assign(url);
    }
    QuickView.prototype.renderFailure = function(productURL, error) {
        this.state.rendering = false;
        this.state.rendered = false;
        this.state.editMode = false;
        this.selector.mainquickmodalview.classList.remove('active');
        this.selector.quickviewmodalrender.innerHTML = '';
        if (this.state.swiper) {
            try { this.state.swiper.destroy(true, true); } catch (destroyError) {}
            this.state.swiper = null;
        }
        if (!window.Swiper) theme.__swiperPromise = null;
        console.error(error);
        this.navigateToProduct(productURL.toString());
    }
    QuickView.prototype.rendercontent = async function(url) {
        var _ = this;
        /* T5.48 — Synchronous in-flight guard: ignore a 2nd open while one is
           still mid-fetch, so a rapid double-tap (or any residual stacked
           listener) can't run concurrent section renders racing the innerHTML
           swap. Cleared in the .finally below. */
        if (_.state.rendering) return;
        const productURL = new URL(url, window.location.origin);
        _.state.rendering = true;
        _.state.rendered = false;
        _.state.editMode = false;
        _.selector.mainquickmodalview.classList.remove('active');
        /* T5.77 — Kick off the on-demand Swiper fetch NOW (no await) so the 151KB
           downloads in PARALLEL with the section fetch below, not sequentially
           after it. The `await theme.ensureSwiper()` before `new Swiper` (in the
           .finally) then resolves from this same cached promise — so first-open
           latency is max(sectionFetch, swiperDownload), not their sum. No-op on
           the PDP (window.Swiper already present) and on every repeat open. */
        theme.ensureSwiper();
        /* T5.46 — Removed the `&_cb=${Date.now()}` cache-buster. It forced Shopify
           to re-render this section UNCACHED on every open; for high-variant
           products that render is slow enough that the first quick-add appeared
           to "do nothing" until a later click hit a warm cache. This reverts to
           T5-2's cacheable fetch (fast). Modal freshness is already covered by the
           inline <style> block in sections/quick-view-modal.liquid, so dropping
           the buster has no staleness downside. */
        await _.loadProductHTML(productURL)
        .then(async () => {
            // T5.55 — destroy the previous Swiper before re-init. The modal re-creates a
            // Swiper on every open with no teardown, leaking the instance + its listeners
            // for the whole session. (INP / memory.)
            if (_.state.swiper) { try { _.state.swiper.destroy(true, true); } catch (e) {} _.state.swiper = null; }
            await theme.ensureSwiper(); // T5.77 — fetch Swiper on demand (no-op on PDP / repeat opens)
            _.state.swiper = await new Swiper(`#quick-view-modal-gallery`, {
                direction: 'horizontal',
                loop: false,                                  
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },                  
                slidesPerView: 1,
                spaceBetween: 0,
              });
            _.selector.mainquickmodalview.classList.add('active');
            const addtocart = _.selector.quickviewmodalrender.querySelector("form#data-product-form");
            if(addtocart) {
                addtocart.addEventListener("submit", event => {
                    event.preventDefault();
                    _.addtocart(event.target);
                })
            }           
            const unavailablemode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .unavailable");
            unavailablemode && unavailablemode.classList.remove("active");
            if(_.state.editMode) {
                const editmode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .edit-mode");
                editmode && editmode.classList.remove("active");
            } else {
                const addmode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .add-mode");
                addmode && addmode.classList.add("active");
            }          
            _.markSizes(); /* T6.08 — grey sold-out sizes on open, like the PDP does on load */
            _.syncAvailability();
            _.state.rendered = true;
        })
        .catch(error => _.renderFailure(productURL, error))
        .finally(() => {
            _.state.rendering = false;
        });
    }
    QuickView.prototype.rendereditcontent = async function(url, itemId, itemKey, itemQty, cartSnapshot) {
        var _ = this;
        if (_.state.rendering) return;
        const productURL = new URL(url, window.location.origin);
        productURL.searchParams.set('variant', itemId);
        _.state.rendering = true;
        _.state.rendered = false;
        _.state.editMode = true;
        _.selector.mainquickmodalview.classList.remove('active');
        theme.ensureSwiper();
        await _.loadProductHTML(productURL)
        .then(async () => {
            // T5.55 — destroy the previous Swiper before re-init. The modal re-creates a
            // Swiper on every open with no teardown, leaking the instance + its listeners
            // for the whole session. (INP / memory.)
            if (_.state.swiper) { try { _.state.swiper.destroy(true, true); } catch (e) {} _.state.swiper = null; }
            await theme.ensureSwiper(); // T5.77 — fetch Swiper on demand (no-op on PDP / repeat opens)
            _.state.swiper = await new Swiper(`#quick-view-modal-gallery`, {
                direction: 'horizontal',
                loop: false,                                  
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },                  
                slidesPerView: 1,
                spaceBetween: 0,
              });
            _.selector.mainquickmodalview.classList.add('active');
            const addtocart = _.selector.quickviewmodalrender.querySelector("form#data-product-form");
            if(addtocart) {
                addtocart._lkcCartSnapshot = cartSnapshot;
                addtocart.addEventListener("submit", event => {
                    event.preventDefault();
                    _.edittocart(event.target, itemKey);
                })
            }          
            const unavailablemode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .unavailable");
            unavailablemode && unavailablemode.classList.remove("active");
            if(_.state.editMode) {
                const editmode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .edit-mode");
                editmode && editmode.classList.add("active");
            } else {
                const addmode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .add-mode");
                addmode && addmode.classList.remove("active");
            }           
            const qtyValue = _.selector.quickviewmodalrender.querySelector('form#data-product-form input[name="quantity"]');
            if(qtyValue) qtyValue.value = itemQty;
            _.markSizes(); /* T6.08 */
            _.syncAvailability();
            _.state.rendered = true;
        })
        .catch(error => _.renderFailure(productURL, error))
        .finally(() => {
            _.state.rendering = false;
        });
    }
    QuickView.prototype.edittocart = async function(form, itemKey) {
        return this.cartOperation(form, itemKey);
    }
    QuickView.prototype.rendereditfreegiftcontent = async function(url, itemId, itemKey, itemQty, cartSnapshot) {
        var _ = this;
        if (_.state.rendering) return;
        const productURL = new URL(url, window.location.origin);
        productURL.searchParams.set('variant', itemId);
        _.state.rendering = true;
        _.state.rendered = false;
        _.state.editMode = true;
        _.selector.mainquickmodalview.classList.remove('active');
        theme.ensureSwiper();
        await _.loadProductHTML(productURL)
        .then(async () => {
            // T5.55 — destroy the previous Swiper before re-init. The modal re-creates a
            // Swiper on every open with no teardown, leaking the instance + its listeners
            // for the whole session. (INP / memory.)
            if (_.state.swiper) { try { _.state.swiper.destroy(true, true); } catch (e) {} _.state.swiper = null; }
            await theme.ensureSwiper(); // T5.77 — fetch Swiper on demand (no-op on PDP / repeat opens)
            _.state.swiper = await new Swiper(`#quick-view-modal-gallery`, {
                direction: 'horizontal',
                loop: false,                                  
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },                  
                slidesPerView: 1,
                spaceBetween: 0,
              });
            _.selector.mainquickmodalview.classList.add('active');
            const addtocart = _.selector.quickviewmodalrender.querySelector("form#data-product-form");
            if(addtocart) {
                addtocart._lkcCartSnapshot = cartSnapshot;
                addtocart.addEventListener("submit", event => {
                    event.preventDefault();
                    _.editfreegifttocart(event.target, itemKey);
                })
            }            
            const unavailablemode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .unavailable");
            unavailablemode && unavailablemode.classList.remove("active");
            if(_.state.editMode) {
                const editmode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .edit-mode");
                editmode && editmode.classList.add("active");
            } else {
                const addmode = _.selector.quickviewmodalrender.querySelector("form#data-product-form > .add-to-cart > .add-mode");
                addmode && addmode.classList.remove("active");
            }    
            const qtyValue = _.selector.quickviewmodalrender.querySelector('form#data-product-form input[name="quantity"]');
            if(qtyValue) qtyValue.value = itemQty;
            let itemPropertyInput = document.createElement("input");
            itemPropertyInput.name = "properties[promo]";
            itemPropertyInput.value = "free";
            itemPropertyInput.type = "hidden";
            const parentElement = _.selector.quickviewmodalrender.querySelector('form#data-product-form');
            const firstChild = parentElement.firstChild;
            parentElement.insertBefore(itemPropertyInput, firstChild);
            _.markSizes(); /* T6.08 */
            _.syncAvailability();
            _.state.rendered = true;
        })
        .catch(error => _.renderFailure(productURL, error))
        .finally(() => {
            _.state.rendering = false;
        });
    }
    QuickView.prototype.editfreegifttocart = async function(form, itemKey) {
        return this.cartOperation(form, itemKey);
    }
    theme.QuickView = new QuickView;
}
theme.QuickView();
